// extracted by mini-css-extract-plugin
module.exports = {"contaier":"ShortcutsResultTitle_contaier__fHQuN","title":"ShortcutsResultTitle_title__69Q5f","unit":"ShortcutsResultTitle_unit__CaWVS"};